import { type FC } from 'react';
import styled from 'styled-components';

import { Show } from '@/components/Show';
import { useUserLocale } from '@/i18n/hooks/useUserLocale';
import { formatNumber } from '@/util/formatNumber';

interface Props {
  amount: number;
  suffix: string;
}

export const TotalAmountCell: FC<Props> = ({ amount, suffix }) => {
  const locale = useUserLocale();

  const formattedTotal = formatNumber(amount, locale, suffix);

  return (
    <Show when={amount > 0}>
      <Container>
        <span className="font-body-demibold">Total:</span>
        <span className="font-body-demibold" id={`total-order-value-${suffix}`}>
          {formattedTotal}
        </span>
      </Container>
    </Show>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  gap: 8px;
  margin-right: 8px;
`;
